import React from "react";

import "./styles.css";

const Skeleton = ({
  variant = "text",
  width,
  height,
  radius,
  className = "",
  style,
}) => (
  <span
    className={`sy-skel sy-skel-${variant} ${className}`}
    aria-hidden="true"
    style={{
      ...(width ? { width } : null),
      ...(height ? { height } : null),
      ...(radius ? { borderRadius: radius } : null),
      ...style,
    }}
  />
);

export const SkeletonText = ({ lines = 3, className = "", widths }) => (
  <span className={`sy-skel-stack ${className}`} aria-hidden="true">
    {Array.from({ length: lines }, (_, index) => (
      <Skeleton
        key={`line-${index}`}
        variant="text"
        width={widths?.[index] || (index === lines - 1 ? "62%" : "100%")}
      />
    ))}
  </span>
);

export const SkeletonCard = ({ media = true, lines = 2, className = "" }) => (
  <span className={`sy-skel-card ${className}`} aria-hidden="true">
    {media && <Skeleton variant="media" />}

    <span className="sy-skel-card-body">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton
          key={`card-line-${index}`}
          variant="text"
          width={index === lines - 1 ? "55%" : "85%"}
        />
      ))}
    </span>
  </span>
);

export const SkeletonRow = ({ className = "" }) => (
  <span className={`sy-skel-row ${className}`} aria-hidden="true">
    <Skeleton variant="avatar" />

    <span className="sy-skel-row-body">
      <Skeleton variant="text" width="60%" />
      <Skeleton variant="text" width="38%" />
    </span>

    <Skeleton variant="text" width="64px" />
  </span>
);

export const SkeletonRegion = ({ label = "Loading", className = "", children }) => (
  <div className={`sy-skel-region ${className}`} role="status" aria-label={label}>
    {children}
  </div>
);

export default Skeleton;
